import { gql } from "lib/apolloClient";

const fragments = {
  categoryFragment: gql`
    fragment categoryItem on AttendanceOption {
      id
      label
      status
      abbreviation
      color
    }
  `,
  courseFragment: gql`
    fragment courseItem on Course {
      id
      title
      learningCourse {
        id
        title
        academicCourse {
          id
          label
        }
      }
    }
  `,
  periodFragment: gql`
    fragment periodItem on Period {
      id
      label
    }
  `,
  staffFragment: gql`
    fragment staffItem on Staff {
      id
      firstName
      lastName
      middleName
      profileImage
    }
  `,
  periodsFragment: gql`
    fragment periodsItem on Period {
      id
      label
      startTime
      endTime
      abbreviation
    }
  `,
  createdByFragment: gql`
    fragment createdByItem on Parent {
      id
      firstName
      lastName
      middleName
      type
    }
  `,
  conversationFragment: gql`
    fragment conversationItem on Conversation {
      id
      parentType
      label
      unreadMessageCount
    }
  `,
};

export const studentAttendanceFragment = {
  attendanceStatisticCategory: gql`
    fragment attendanceStatisticCategoryItem on AttendanceStatisticCategoryItem {
      percentage
      item {
        ...categoryItem
      }
    }
    ${fragments.categoryFragment}
  `,
  attendanceStatisticCourse: gql`
    fragment attendanceStatisticCourseItem on AttendanceStatisticCourseItem {
      percentage
      item {
        ...courseItem
      }
    }
    ${fragments.courseFragment}
  `,
  attendanceRecordStats: gql`
    fragment attendanceRecordStatsItem on AttendanceFilteredStatistic {
      totalCount
      filteredCount
      percentage
    }
  `,
  attendanceExcusal: gql`
    fragment attendanceExcusalItem on AttendanceExcusal {
      id
      student {
        id
        firstName
        middleName
        lastName
        preferredName
        suffix
        pronouns
      }
      durationType
      startDate
      endDate
      periods {
        ...periodsItem
      }
      reason
      createdBy {
        ...createdByItem
      }
      createdAt
      conversation {
        ...conversationItem
      }
      attendanceOption {
        id
      }
    }
    ${fragments.periodsFragment}
    ${fragments.createdByFragment}
    ${fragments.conversationFragment}
  `,
  attendanceRecord: gql`
    fragment attendanceRecordItem on StudentDateAttendance {
      id
      date
      remark
      status
      updatedAt
      updatedBy {
        ...staffItem
      }
      period {
        ...periodItem
      }
      course {
        ...courseItem
      }
      category: value {
        ...categoryItem
        attendanceCategory {
          id
          color
        }
      }
      isHomeroomAttendance
    }
    ${fragments.categoryFragment}
    ${fragments.courseFragment}
    ${fragments.periodFragment}
    ${fragments.staffFragment}
  `,
};
